/** Textos da secção "howto". Chaves planas "howto.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "howto.eyebrow": "Processo simples",
    "howto.title": "Como Comprar",
    "howto.step1.title": "Entra com Discord + SteamID",
    "howto.step1.desc": "Login Discord e SteamID no perfil ZRS (obrigatório).",
    "howto.step2.title": "Faz o pagamento via Pix",
    "howto.step2.desc": "Rápido, seguro e em reais.",
    "howto.step3.title": "Abre ticket no Discord",
    "howto.step3.desc": "Envia o comprovante e dados de jogo.",
    "howto.step4.title": "Recebe in-game",
    "howto.step4.desc": "Benefícios aplicados na hora.",
};
const en = {
    "howto.eyebrow": "Simple process",
    "howto.title": "How to Buy",
    "howto.step1.title": "Sign in with Discord + SteamID",
    "howto.step1.desc": "Discord login and SteamID on your ZRS profile (required).",
    "howto.step2.title": "Pay via Pix",
    "howto.step2.desc": "Fast, secure and in Brazilian reais (BRL).",
    "howto.step3.title": "Open a ticket on Discord",
    "howto.step3.desc": "Send your payment receipt and in-game details.",
    "howto.step4.title": "Get it in-game",
    "howto.step4.desc": "Perks applied instantly.",
};

export default { pt, en };
